// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import Profile from './Profile';
import MobileSection from './MobileSection';
import LanguageSwitcher from 'components/LanguageSwitcher';
import { useShellConfig } from 'contexts/ShellConfigContext';

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { HeaderExtras } = useShellConfig();

  return (
    <>
      <Box sx={{ width: '100%', ml: 1 }} />
      {HeaderExtras ? <HeaderExtras /> : null}
      <LanguageSwitcher />
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
